module.exports = __webpack_public_path__ + "img/Voltar.adcef2b7.svg";